import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import "./card.css";
import { useSelector } from "react-redux";
import ImageComponent from "../Image/image";
import { VideoSecuredComponent } from "../Video/video";

function CustomCard(props) {
  const user = useSelector((state) => state.compteReducers.userConnected);
  useEffect(() => {
    // console.log("checking", props, user);
  }, []);
  return (
    <Card className="my-3 customCard">
      <Card.Body className="panel">
        <Card.Title className="k-semibold-20">{props.label}</Card.Title>
        <div>
          {props?.data?.map((value, index) => {
            return (
              <Link
                style={{ textDecoration: "none" }}
                className="item d-flex align-items-center mt-2 pointer-cursor text-dark"
                // key={value?.content?.id}
                key={`${value?.id}${index}`}
                to={{
                  pathname:
                    props.label === "Profile"
                      ? `/details-user/${value?.pseudo}`
                      : `/details-content/${value?.content?.id}`,
                  state: {},
                }}
              >
                <div className="item d-flex align-items-center mt-2 pointer-cursor w-100">
                  <div className="image">
                    {props.label === "Profile" && (
                      <ImageComponent
                        isRounded={true}
                        src={
                          props.label === "Profile"
                            ? value?.profil
                            : value?.content?.illustrations[0]?.url
                        }
                        alt=""
                        className="img-fluid mr-2"
                      />
                    )}
                    {props.label === "Photos" && (
                      <ImageComponent
                        isRounded={true}
                        src={
                          props.label === "Profile"
                            ? value?.profil
                            : value?.content?.illustrations[0]?.url
                        }
                        alt="profil"
                        className="img-fluid mr-2"
                      />
                    )}
                    {props.label === "Videos" && (
                      <VideoSecuredComponent
                        src={value?.content?.illustrations[0]?.url}
                        className=" rounded-circle rounded_44 mr-3"
                      >
                        Sorry, your browser doesn't support embedded videos.
                      </VideoSecuredComponent>
                    )}
                  </div>
                  <div className=" mr-auto d-flex flex-column text-truncate">
                    {props.label === "Profile" ? ( // text
                      <>
                        <p>{value?.pseudo}</p>
                        {value?.online ? (
                          <div className="label-online d-flex align-items-center">
                            <dot className="dot"></dot>
                            <p className="k-semibold-11 textGreen font-italic online">
                              online
                            </p>
                          </div>
                        ) : (
                          <div className="label-offline d-flex  align-items-center">
                            <div className="dot bg-secondary"></div>
                            <p className="k-regular-11 text-secondary font-italic offline">
                              offline
                            </p>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <p>{value.content?.user?.pseudo}</p>
                        <p className="k-regular-11 text-secondary font-italic">
                          {value?.content?.legend
                            .split(" ")
                            .slice(0, 2)
                            .join(" ")}{" "}
                          ...
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </Card.Body>
    </Card>
  );
}

export default CustomCard;
